export default function validate(fields) {
    const errors = {}
    const { clientId, siteId, description, address, timeZone  } = fields
    if (typeof clientId === 'undefined' || clientId === '') {
        errors.clientId = 'Client Id must not be empty'
    }
    if (typeof siteId === 'undefined' || siteId === '') {
        errors.siteId = 'Site Id must not be empty'
    }
    if (typeof description === 'undefined' || description === '') {
        errors.description = 'Description must not be empty'
    }
    if (typeof address === 'undefined' || address === '') {
        errors.address = 'Address must not be empty'
    }
    if (typeof timeZone === 'undefined' || timeZone === '') {
        errors.timeZone = 'Time Zone must not be empty'
    }
    return errors
}



// WEBPACK FOOTER //
// ./src/smart-components/client-config-form/validate.js